import StructuralUnitIcon from "@mui/icons-material/School";
import { AdministrationServicePath, DIRECTIONS } from "../../../utils/constants";
import ListDirections from "./List";
import CreateDirections from "./Create";
import EditDirections from "./Edit";
import ShowDirections from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <StructuralUnitIcon />,
  name: AdministrationServicePath + DIRECTIONS,
  title: "Направления",
  list: <ListDirections />,
  create: <CreateDirections />,
  createPermission: permissions.canCreateDirections,
  edit: <EditDirections />,
  editPermission: permissions.canUpdateDirections,
  show: <ShowDirections />,
  showPermission: permissions.canPreviewDirections,
  permission: permissions.canPreviewDirections,
};
